<template>
  <div class="flex flex-col gap-4 w-full h-full items-center justify-center">
    <div class="card-no-grow sm:rounded-2xl w-full sm:w-96 h-full sm:h-auto">
      <div class="py-10 flex flex-col flex-grow gap-4">
        <div class="flex-grow flex flex-col gap-4">
          <img
            class="w-64 h-64 mx-auto"
            :class="{ 'animated': animateImage }"
            alt="SyncFDY Logo"
            :src="LogoImage"
          >
          <h3 class="text-4xl text-center">
            <b>SyncFDY</b>
          </h3>
        </div>
        <h3 class="text-2xl text-center">
          Login
        </h3>
        <div class="flex justify-center items-center gap-4">
          <Button
            class="w-36"
            severity="secondary"
            label="Salesforce"
            @click="login"
          >
            <template #icon>
              <img
                :src="SfdcImage"
                alt="Salesforce Logo"
                class="w-6 h-6"
              >
            </template>
          </Button>
          <Button
            severity="secondary"
            class="w-36"
            icon="pi pi-id-card"
            label="Biometric"
            @click="webauthn"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import LogoImage from '@/assets/logo.png?w=256&h=256&format=webp&imagetools'
import SfdcImage from '@/assets/sfdc.png?w=42&h=42&format=webp&imagetools'
import { useRoute, useRouter } from 'vue-router'
import { startAuthentication } from '@simplewebauthn/browser'
import { useAuth } from '@/composables/auth'
import { ref } from 'vue'
import api from '@/lib/api'

const login = () => (location.href = '/hk/v1/auth/login' + (route.name !== 'Login' ? '?originalUrl=' + encodeURIComponent(location.href) : '?originalUrl=' + encodeURIComponent(baseUrl)))
const baseUrl = import.meta.env.BASE_URL
const { checkAuth, isAuthenticated } = useAuth()
const route = useRoute()
const router = useRouter()
const animateImage = ref(false)

const webauthn = async () => {
  const optionsJSON = await api.webauthn.getAuthenticationOptions(localStorage.getItem('userid'))
  let asseResp
  try {
    asseResp = await startAuthentication({ optionsJSON })
  } catch (error) {
    console.error(error)
    throw error
  }

  const verificationJSON = await api.post('/webauthn/verify-authentication', {
    assertion: asseResp,
    userId: localStorage.getItem('userid')
  })

  console.log(verificationJSON)
  animateImage.value = true
  setTimeout(() => {
    checkAuth()
    if (isAuthenticated.value) {
      router.replace(/** @type {string} */ (route.query.redirectTo)?.replace(baseUrl, '') || '/')
    } else {
      animateImage.value = false
    }
  }, 1000)
}
</script>
<style>
@keyframes rotazione {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

img.animated {
  animation: rotazione 2s linear infinite;
}
</style>
